// extracted by mini-css-extract-plugin
export default {"text":"styles_text__disPJ","reset":"styles_reset__1Huvn","clickArea":"styles_clickArea__CtqqT"};